import React from "react";

interface MobileNavMoreIconProps {
  className?: string;
}

function MobileNavMoreIcon({ className }: MobileNavMoreIconProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="6.302"
      height="25.21"
      viewBox="0 0 6.302 25.21"
      aria-hidden="true"
      focusable="false"
    >
      <g
        id="_3_Blue_Dot"
        data-name="3 Blue Dot"
        transform="translate(6.302 25.21) rotate(-180)"
      >
        <g id="Group_124" data-name="Group 124" transform="translate(0 0)">
          <path
            id="Path_117"
            data-name="Path 117"
            d="M5.379.923a3.151,3.151,0,1,1-4.456,0,3.151,3.151,0,0,1,4.456,0"
            transform="translate(0 0)"
            fill="#03f"
          />
          <path
            id="Path_118"
            data-name="Path 118"
            d="M5.379.923a3.151,3.151,0,1,1-4.456,0,3.151,3.151,0,0,1,4.456,0"
            transform="translate(0 9.454)"
            fill="#03f"
          />
          <path
            id="Path_119"
            data-name="Path 119"
            d="M5.379.923a3.151,3.151,0,1,1-4.456,0,3.151,3.151,0,0,1,4.456,0"
            transform="translate(0 18.907)"
            fill="#03f"
          />
        </g>
      </g>
    </svg>
  );
}

export default MobileNavMoreIcon;
